import { render, staticRenderFns } from "./dietReport.vue?vue&type=template&id=5356c79e&scoped=true&"
import script from "./dietReport.vue?vue&type=script&lang=js&"
export * from "./dietReport.vue?vue&type=script&lang=js&"
import style0 from "./dietReport.vue?vue&type=style&index=0&id=5356c79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5356c79e",
  null
  
)

export default component.exports